import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { verifyAccountLink } from '../../../settings/staticUrl'
import { Text, View } from '@olxbr/design-system'
import ShieldPurpleIcon from '../../atoms/ShieldPurpleIcon'
import { ChevronRight } from '@olxbr/ds-icons'
import mediaQuery from '../../../util/medias'

import Link from '../../atoms/Link'

const Content = styled(View)`
  display: flex;
  flex-direction: row;
  position: relative;

  ${mediaQuery.medium`
    flex-direction: column;
  `}
`

const Info = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: -14px;

  ${mediaQuery.medium`
    order: 2;
    margin-left: 0;
  `}
`

const Icon = styled(View)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 26px;

  ${mediaQuery.medium`
    order: 1;
    align-self: flex-start;
    padding-right: 0;
    padding-bottom: 16px;
  `}
`

const BlockText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 4px;
  padding-right: 36px;
`
const TextBold = styled(Text)`
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 4px;
  padding-right: 36px;
`
const TextTitle = styled(Text)`
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 4px;
  padding-right: 36px;
`

const GoToTipsPageLink = styled(Link)`
  text-align: left;
  display: flex;
  align-items: center;
  gap: 4px;
`

const SecurityTipsModal = ({ accountVerified, onVerifyAccountLink }) => {
  const onVerifyAccountLinkClick = useCallback(() => {
    if (typeof onVerifyAccountLink === 'function') {
      onVerifyAccountLink()
    }
  }, [onVerifyAccountLink])

  const getVerifyAccountUrl = useCallback(() => {
    const baseUrl = verifyAccountLink
    const separator = baseUrl.includes('?') ? '&' : '?'
    return `${baseUrl}${separator}lis=security_central`
  }, [])

  return (
    <Content>
      <Icon>
        <ShieldPurpleIcon />
      </Icon>
      <Info>
        <BlockText>
          {accountVerified ? (
            <>
              <TextTitle>
                <strong>Sua conta está verificada, </strong>e isso faz a diferença.
              </TextTitle>
              <br />
              Agora você pode negociar com mais confiança e segurança na OLX.
            </>
          ) : (
            <>
              <TextBold>Ganhe o seu selo de verificado e negocie mais rápido.</TextBold> <br />
              Faça a verificação de identidade e negocie com mais confiança dentro da OLX.
            </>
          )}
        </BlockText>

        {!accountVerified && (
          <GoToTipsPageLink
            preventHrefOnClick={false}
            href={getVerifyAccountUrl()}
            onClick={onVerifyAccountLinkClick}
            type="primary"
            underline={false}
          >
            Verificar meu perfil <ChevronRight size="18" />
          </GoToTipsPageLink>
        )}
      </Info>
    </Content>
  )
}

SecurityTipsModal.propTypes = {
  onVerifyAccountLink: PropTypes.func,
  accountVerified: PropTypes.bool,
}

export default SecurityTipsModal
